export default "__VITE_ASSET__DNO6RnkC__"